import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filename_filter',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    }
    return value.filter((val) => {
      let rVal = (val.name.toLocaleLowerCase().includes(args));
      return rVal;
    })

  }

}